import { constants } from 'helpers';
import type { TestResult } from 'v2/interfaces/delivery-providers';
import deliveryProvidersService from 'v2/services/delivery-providers';

export interface IProps {
  isModal: boolean;
  open?: boolean;
  onClose?: (...args: any[]) => any;
  onOk: (...args: any[]) => any;
  other?: IDelivery;
  newProduct?: boolean;
  alphaclass?: boolean;
  hasHotmart?: boolean;
  deliveries?: IDelivery[];
}

interface IDelivery {
  id: number;
  method_id: number;
  method_name: string;
  url: string;
  can_modify: boolean;
}

export interface IOther {
  id: number;
  name: string;
  type: string;
  parameters: IParameters[];
}

interface IParameters {
  hint: string;
  name: string;
  label: string;
  size: number;
  regexp: string;
  required: boolean;
}

const { APOLLO, CUSTOM, LEADLOVERS, EADPLATAFORMA, WEVE } = constants.PROVIDERS;

export const PROVIDER_CONFIG: Record<
  number,
  {
    testUrl: (url: string) => Promise<TestResult>;
    preposition: string;
  }
> = {
  [CUSTOM.ID]: {
    testUrl: deliveryProvidersService.customTestUrl,
    preposition: CUSTOM.PREPOSITION
  },
  [WEVE.ID]: {
    testUrl: deliveryProvidersService.customTestUrl,
    preposition: WEVE.PREPOSITION
  },
  [LEADLOVERS.ID]: {
    testUrl: deliveryProvidersService.leadloversTestUrl,
    preposition: LEADLOVERS.PREPOSITION
  },
  [EADPLATAFORMA.ID]: {
    testUrl: deliveryProvidersService.customTestUrl,
    preposition: EADPLATAFORMA.PREPOSITION
  },
  [APOLLO.ID]: {
    testUrl: deliveryProvidersService.apolloTestUrl,
    preposition: APOLLO.PREPOSITION
  }
};
